import PropTypes from 'prop-types';
// @mui
import { Grid } from '@mui/material';
// components
import { RHFTextField } from '../../../../../components/hook-form';
import CardSection from '../../../../../components/card-section';

//-------------------------------------------------------------------------------------------------

const YearFields = ({ onRemove, isRemoveDisabled, index }) => (
  <CardSection title={`Prior Carrier #${index + 1}`} onRemove={() => onRemove(index)} isRemoveDisabled={isRemoveDisabled}>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <RHFTextField name={`currentCoverage[${index}].year`} label={'Year'}/>
      </Grid>
      <Grid item xs={12} sm={4}>
        <RHFTextField name={`currentCoverage[${index}].carrier`} label={'Carrier'} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <RHFTextField name={`currentCoverage[${index}].policyNumber`} label={'Pol #'} />
      </Grid>
    </Grid>
  </CardSection>
);

YearFields.propTypes = {
  onRemove: PropTypes.func,
  isRemoveDisabled: PropTypes.bool,
  index: PropTypes.number,
};

export default YearFields;
